<template>
  <div class="content">
    <PageHeader :title="$tc('app.tracker', 2)" />
    <section class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <CardComponent variant="tertiary">
            <template #header>
              {{ $tc('app.tracker', 2) }}
              <ul class="actions top-right">
                <li>
                  <ButtonComponent variant="light" @click="$refs['create-tracker'].toggle()" is-icon>
                    <span class="material-symbols-outlined">add</span>
                  </ButtonComponent>
                </li>
                <li>
                  <ButtonComponent variant="light" @click="showFilter" is-icon>
                    <span class="material-symbols-outlined">filter_list</span>
                  </ButtonComponent>
                </li>
                <li>
                  <ButtonComponent variant="light" @click="fetch(1)" is-icon>
                    <span class="material-symbols-outlined">refresh</span>
                  </ButtonComponent>
                </li>
              </ul>
            </template>
            <TableComponent :busy="loading" :fields="fields" :items="trackers">
              <template #cell()="slotProps">
                <ButtonComponent variant="danger" @click="deleteTracker(slotProps.item.id)">
                  <span class="material-symbols-outlined">delete</span>
                </ButtonComponent>
              </template>
            </TableComponent>
            <PaginationComponent v-model="form.page" :total-pages="pages" @change="fetch" />
          </CardComponent>
        </div>
      </div>
    </section>
    <SidebarComponent ref="create-tracker" title="Criar Rastreador">
      <InputComponent :name="$t('app.mobile_number')" type="text" :label="$tc('app.mobile_number', 1)" placeholder="5513999999999" v-model="form.number"></InputComponent>
      <SelectComponent v-model="form.account_id" :label="$tc('app.account', 1)" :options="customers" text-field="name" value-field="id"></SelectComponent>
      <template #footer>
        <div class="d-flex justify-content-between">
          <ButtonComponent @click="$refs['create-tracker'].toggle()" variant="secondary">Cancelar</ButtonComponent>
          <ButtonComponent @click="storeTracker()">Criar</ButtonComponent>
        </div>
      </template>
    </SidebarComponent>
    <SidebarComponent ref="filter" title="Filtros">
      <InputComponent :name="$t('app.mobile_number')" type="text" :label="$tc('app.mobile_number', 1)" placeholder="5513999999999" v-model="filter.number"></InputComponent>
      <SelectComponent v-model="filter.account_id" :label="$tc('app.account', 1)" :options="customers" text-field="name" value-field="id"></SelectComponent>
      <template #footer>
        <div class="d-flex justify-content-between">
          <ButtonComponent @click="cleanFilter" variant="secondary">Limpar</ButtonComponent>
          <ButtonComponent @click="applyFilter">Aplicar Filtros</ButtonComponent>
        </div>
      </template>
    </SidebarComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import PageHeader from '@/components/PageHeader.vue';
import CardComponent from '@/components/CardComponent.vue';
import TableComponent from '@/components/TableComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import SelectComponent from '@/components/form/SelectComponent.vue';
import CustomerService from '@/services/customer.service';

export default {
  name: 'Monitor',
  components: {
    PageHeader,
    CardComponent,
    TableComponent,
    PaginationComponent,
    ButtonComponent,
    SidebarComponent,
    InputComponent,
    SelectComponent,
  },
  data() {
    return {
      loading: false,
      pages: 0,
      fields: [
        {
          key: 'number',
        },
        {
          key: 'account.name',
          label: this.$tc('app.account'),
        },
        {
          key: 'created_at',
          formatter: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
        },
        '',
      ],
      trackers: [],
      customers: [],
      filter: {
        number: '',
        account_id: '',
      },
      form: {
        filter: {
          number: '',
          account_id: '',
        },
        page: 1,
        limit: 10,
      },
    };
  },
  created() {
    this.fetch(1);
    this.fetchCustomers();
  },
  methods: {
    fetch(page = 1) {
      this.loading = true;
      this.form.page = page;
      this.$store
        .dispatch('fetchSmsTrackers', this.form)
        .then((response) => {
          this.trackers = response.data;
          this.pages = response.last_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchCustomers() {
      CustomerService.getCustomers().then(
        (customers) => {
          this.customers = customers;
          this.customers.push(this.$store.state.account);
        },
        (error) => {
          this.content = error;
        },
      );
    },
    storeTracker() {
      this.loading = true;
      this.$store
        .dispatch('storeSmsTrackers', this.form)
        .then((response) => {
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showFilter() {
      this.$refs.filter.toggle();
    },
    applyFilter() {
      this.form.filter = this.filter;
      this.$refs.filter.hide();
      this.$nextTick(() => this.fetch(1));
    },
    cleanFilter() {
      this.filter = {
        number: '',
        account_id: '',
      };
    },
    deleteTracker(id) {
      this.loading = true;
      this.$store.dispatch('destroySmsTracker', id).then(() => {
        this.fetch(1);
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
